




import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { Patient, Worker, isWorker, Relative, isRelative } from '@/types/user'
import { ExStore } from 'vuex'

export type ChangeEvent = {
  checked: boolean
  active: boolean
}

@Component({
  components: {
    CheckboxInput: () => import('@/components/common/StyledCheckboxInput.vue')
  }
})
export default class CallCheckboxInput extends Vue {
  $store!: ExStore
  @Prop() user!: Patient | Worker | Relative

  @Emit('change')
  onChange(checked: boolean): ChangeEvent {
    return { checked, active: this.active }
  }

  @Watch('active')
  onChangeActive() {
    if (this.checked && !this.active) {
      this.checked = false
    }
  }

  @Watch('isCallPartner')
  onChangeChecked(isPartner: boolean) {
    if (isPartner && !this.active) {
      this.checked = false
    }
  }

  get checked() {
    return this.isCallPartner
  }

  set checked(checked: boolean) {
    const action = checked ? 'call/addCallPartners' : 'call/removeCallPartners'
    this.$store.dispatch(action, [this.user])
    this.onChange(checked)
  }

  get isCallPartner() {
    return !!this.callPartners.find(user => user.id === this.user.id)
  }

  get callPartners() {
    return this.$store.getters['call/callPartners']
  }

  get onlineStatus() {
    return this.$store.getters['onlineStatus/onlineStatus']
  }

  get active() {
    //1,家族が選択されている場合、医療従事者は選択できない
    //2,患者が一人でも選択されている場合、他の患者は選択できない
    //3,チームを跨いで患者または医療従事者を選択できない
    //4,「応答可/応答不可」(user.app_settings.isOnline) 設定で切り替え
    //  4.1,医療従事者は「応答可/応答不可」設定で切り替え
    //  4.2,患者・家族は常に有効 (応答可/応答不可の設定が存在しない)
    const user = this.user //対象のユーザー
    const worker = this.callPartners.find(user => isWorker(user)) //選択済みの医療従事者
    const patient = this.callPartners.find(
      user => !isWorker(user) && !isRelative(user)
    ) //選択済みの患者
    const relative = this.callPartners.find(user => isRelative(user)) //選択済みの家族

    if (relative && !isRelative(this.user)) return false //1
    if (isWorker(user)) {
      //対象が医療従事者の場合

      //対象従事者と選択済みの患者が同じチームかチェック //3
      if (
        patient &&
        !this.$store.getters['team/isPatientsTeam'](patient.id, user.id)
      )
        return false

      //対象従事者と選択済みの従事者が同じチームかチェック //3
      if (
        worker &&
        worker.id !== user.id &&
        !this.$store.getters['team/isSameTeam'](worker.id, user.id)
      )
        return false
    } else {
      //対象が患者または家族の場合

      //対象患者・家族と選択済みの従事者が同じチームかチェック //3
      if (
        worker &&
        !this.$store.getters['team/isPatientsTeam'](user.id, worker.id)
      )
        return false

      //患者が一人でも選択されている場合、選択できない //2
      if (patient && patient.id !== user.id) return false
    }

    //「応答可/応答不可」設定で切り替え //4

    if (isWorker(this.user)) {
      //医療従事者は設定で切り替え //4.1
      //this.onlineStatus[this.user.id] が undefined
      //  = OnlineUserViewから除外されている
      //  = user.is_dont_disturb_mode() (!user.app_settings.isOnline)
      //  = 応答不可
      // return !(this.onlineStatus[this.user.id] === undefined)
      return (
        this.onlineStatus[this.user.id] &&
        this.onlineStatus[this.user.id].isOnline
      )
    }

    // 患者・家族は常に有効 (応答可/応答不可の設定がないため) // 4.2
    return true
  }
}
